export const CHIP_REVIEW_KEY = "ITEMS_TEXT.CHIP_REVIEW_APPROVAL";

const permissionEnabled = (permissions, path) => path.split('.').reduce((value, key) => value?.[key], permissions || {}) === true;
const normalize = (value) => String(value || "").trim().replace(/\s+/g, " ").toLowerCase();

export const canReviewChip = (user) => Number(user?.user_id) === 1
  || permissionEnabled(user?.role?.permissions || user?.permissions, 'chip_governance.manage_chip_rules')
  || permissionEnabled(user?.role?.permissions || user?.permissions, 'app_settings.manage_chip_rules');

export const chipReviewAlias = (value) => {
  const name = normalize(value).replace(/^items_text\./, "");
  return ["chip_review_approval", "chip_learning_rules", "recommendation_acceptance",
    "chiplearningrules", "recommendationacceptance"].includes(name) ? CHIP_REVIEW_KEY : null;
};
